<template>
  <span> {{ formattedTime }} </span>
</template>

<script>
import { countdown } from "../lib/time";

export default {
  name: "CountdownTimer",
  components: {},
  props: ["time"],
  data() {
    return {
      timer: null,
      formattedTime: ""
    };
  },
  mounted() {
    this.setTimer();
    this.updateTime();
  },
  watch: {
    time() {
      console.log("time changed");
      this.clearTimer();
      this.setTimer();
    }
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    updateTime() {
      this.formattedTime = countdown(this.time);
    },
    setTimer() {
      this.timer = setInterval(() => this.updateTime(), 1000);
    },
    clearTimer() {
      if (this.timer) clearInterval(this.timer);
    }
  }
};
</script>
